export default "__VITE_ASSET__B1awWo3k__"